import { render, staticRenderFns } from "./UpView.vue?vue&type=template&id=2e83fd5a&"
import script from "./UpView.vue?vue&type=script&lang=js&"
export * from "./UpView.vue?vue&type=script&lang=js&"
import style0 from "./UpView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./UpView.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports